var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { C } from '#integrations';
import styles from './WordBreak.module.css';
export const WordBreak = ({ children, className }) => (_jsx("span", { className: C(styles.Container, className), children: children }));
_react_refresh_temp_1 = WordBreak;
$RefreshReg$(_react_refresh_temp_1, "WordBreak");
